import { useEffect, useEffectEvent } from 'react';

export default (eventFn = () => {}, deps = []) => {
  const trackEvent = useEffectEvent(eventFn);

  useEffect(() => {
    trackEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
